import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgClock = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M14.5 8a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0M0 8a8 8 0 1 0 16 0A8 8 0 0 0 0 8m7.25-4.25V8c0 .25.125.484.334.625l3 2a.75.75 0 0 0 1.041-.21.747.747 0 0 0-.21-1.04L8.75 7.6V3.75A.75.75 0 0 0 8 3a.75.75 0 0 0-.75.75"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgClock);
export default ForwardRef;
